<template>
  <SvgWrapper viewBox="0 0 512 512">
    <path fill="currentColor" d="M96 197.333h320v32H96zm72 101.334h176v32H168zM216 400h80v32h-80zM48 96h416v32H48z"/>
  </SvgWrapper>
</template>

<script>
import SvgWrapper from "./SvgWrapper";

export default {
  components: {SvgWrapper},
};
</script>
